import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
	OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { CustomerSupportService } from "@obg/core.customer-support";
import { AbstractTranslatableAlertService, CORE_ROUTE, CoreState, LoadingService } from "@obg/ngx.core";
import { TranslationGroup, TranslationSelector } from "@obg/ngx.core.content";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { RouteAction } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { FORGOT_PASSWORD_TRANSLATIONS } from "../../forgot-password.model";
import { ForgotPasswordService } from "../../forgot-password.service";

const FORGOT_PASSWORD_SUCCESS_ALERT_ID = "FORGOT_PASSWORD_SUCCESS_ALERT_ID";

@Component({
	selector: "obg-m-sm-forgot-password-email-container",
	templateUrl: "./sm-forgot-password-email.container.html",
	styleUrls: ["./sm-forgot-password-email.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [ForgotPasswordService],
})
export class SmForgotPasswordEmailContainer implements OnInit {
	@HostBinding("class.obg-m-sm-forgot-password-email") hostCssClass = true;

	@Input()
	@coerceBoolean()
	hideFooter = false;

	@Input()
	@coerceBoolean()
	customUsageEnabled = false;

	@Output() close = new EventEmitter();

	fabricForgotPasswordComponent = this.forgotPasswordService.getFabricForgotPasswordFeatureFlag();
	translations$: Observable<Record<string, string | undefined>> | undefined;

	constructor(
		private store: Store<CoreState>,
		private loadingService: LoadingService,
		private translatableAlertService: AbstractTranslatableAlertService,
		private customerSupportService: CustomerSupportService,
		private translationSelector: TranslationSelector,
		private forgotPasswordService: ForgotPasswordService
	) {}

	ngOnInit() {
		this.translations$ = this.store.pipe(
			this.translationSelector.getByKeys_v2$(FORGOT_PASSWORD_TRANSLATIONS.translations, [
				TranslationGroup.General,
				TranslationGroup.Common,
			]),
			map((keys) =>
				Object.fromEntries(keys.map((_, i) => [FORGOT_PASSWORD_TRANSLATIONS.translations[i], keys[i]]))
			)
		);
	}

	showSuccessAlert() {
		this.translatableAlertService.open(
			{
				id: FORGOT_PASSWORD_SUCCESS_ALERT_ID,
				title: "forgot-password.success-title",
				message: "forgot-password.success-message",
				hideClose: true,
				dialogConfig: {
					disableClose: true,
				},
				buttons: [
					{
						text: "general.close",
						handler: () =>
							this.customUsageEnabled
								? this.close.emit()
								: this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home)),
					},
					{
						text: "general.contact",
						handler: () => {
							if (this.customUsageEnabled) {
								this.close.emit();
							}
							this.customerSupportService.openSupportPageInNewTab();
						},
					},
				],
			},
			[TranslationGroup.Common]
		);
	}

	toggleLoading(isBusy: boolean) {
		if (isBusy) {
			this.loadingService.open();
			return;
		}
		this.loadingService.close();
	}
}
